import angular from 'angular';
import booksMenu from '../../menu/Menu';
import booksDom from '../../booksDom';
import fundraisersTemplate from './fundraisers.html';
import { FundraiserService } from './services/FundRaiser';
import {
  AddChangeFundraiserDialogService,
  addChangeFundraiserComponent
} from './dom/AddChangeFundraiserDialog';
import { summaryContentComponent } from './dom/fundraiserItemsDialog/summary';
import { itemsComponent } from './dom/fundraiserItemsDialog/items';
import {
  FundraiserItemsDialogService,
  TemplateCacheTabs,
  TAB_TYPE,
  FUNDRAISER_ITEM_TYPES,
  fundraiserItemsDialogComponent
} from './dom/fundraiserItemsDialog/fundraiserItemsDialog';
import { fundItemsComponent } from './dom/fundraiserItemsDialog/fundItems/fundItems';
import {
  AddChangeFundraiserItemDialogService,
  addChangeFundraiserItemDialogComponent
} from './dom/fundraiserItemsDialog/AddChangeFundraiserItemDialog/AddChangeFundraiserItemDialog';
import {
  ItemsNotSoldDialogService,
  ItemsNotSoldDialogComponent
} from './dom/fundraiserItemsDialog/AddChangeFundraiserItemDialog/ItemsNotSoldDialog/ItemsNotSoldDialog';
import { activityComponent } from './dom/fundraiserItemsDialog/activity';
import { activityItemsComponent } from './dom/fundraiserItemsDialog/activityItems/activityItems';

/*****************************************************************************
* @ngdoc    component
* @name     csm.books.fundraisers.component:fundraisers
* @param    {Array}       fundraisersList      List of Fundraisers or Programs
* @param    {Number}      clubId               Club ID to use when creating a new 
*                                              Fundraiser. Programs will ignore this.
* @param    {Boolean}     isPrograms           Boolean indication the component is 
*                                              handling programs.
* @param    {Boolean}     useExpenseRevenue    Boolean indication to use Revenue/Expense
*                                              labels in the FundraiserItemDialog when
*                                              viewing fundraiser activity data.
* @param    {Expression}  handleProgramDelete    
* @param    {Expression}  handleProgramGet     
* @param    {Expression}  handleProgramSave   


* @description
* The Fundraisers app component. This variable needs to be declared and hoisted
* before it is used as a component below, otherwise it will not be found during
* the creation of the module component.
*****************************************************************************/
var fundraisersComponent = {
  controller: controller,
  template: fundraisersTemplate,
  bindings: {
    fundraisersList: '<',
    clubId: '<',
    isPrograms: '<',
    useExpenseRevenue: '<',
    handleProgramDelete: '&',
    handleProgramGet: '&',
    handleProgramSave: '&'
  }
};

/*******************************************************************************
 * @ngdoc overview
 * @name  fundraisers
 *
 * @description
 * Fundraisers Management
 *******************************************************************************/
export default angular
  .module('csm.books.fundraisers', [booksMenu, 'ui.grid', booksDom])
  .component('fundraisers', fundraisersComponent)
  /** FundRaiser */
  .service('FundRaiser', FundraiserService)
  /** addChangeFundraiserItemDialog */
  .service(
    'AddChangeFundraiserItemDialog',
    AddChangeFundraiserItemDialogService
  )
  .component('addChangeFundraiserItem', addChangeFundraiserItemDialogComponent)
  /** ItemsNotSoldDialog */
  .service('ItemsNotSoldDialog', ItemsNotSoldDialogService)
  .component('itemsNotSold', ItemsNotSoldDialogComponent)
  /** fundraiserItemsDialog */
  .service('FundraiserItemsDialog', FundraiserItemsDialogService)
  .constant('FundraiserItemTypes', FUNDRAISER_ITEM_TYPES)
  .constant('TabType', TAB_TYPE)
  .component('fundraiserItemsDialog', fundraiserItemsDialogComponent)
  .run(TemplateCacheTabs)
  /** fundItems */
  .component('fundItems', fundItemsComponent)
  /** activityItems */
  .component('activityItems', activityItemsComponent)
  /** Summary */
  .component('summaryContent', summaryContentComponent)
  /** Activity */
  .component('activity', activityComponent)
  /** Items */
  .component('items', itemsComponent)
  /** AddChangeFundraiserDialog */
  .service('AddChangeFundraiserDialog', AddChangeFundraiserDialogService)
  .component('addChangeFundraiser', addChangeFundraiserComponent).name;

/*****************************************************************************
 * Controller: controller */
/**
 * @ngdoc     controller
 * @module    csm.books.fundraisers
 * @name      csm.books.fundraisers.controller:MainController
 * @description
 * Main controller for {@link fundraisers}
 *****************************************************************************/
/* @ngInject */ function controller($injector, $q, $scope, BusyScreen) {
  var $ctrl = this;
  var $utils = {};

  $ctrl.changeFundraiser = $injector.invoke(changeFundraiser, null, {
    $ctrl: $ctrl
  });
  $ctrl.dropFundraiser = $injector.invoke(dropFundraiser, null, {
    $ctrl: $ctrl
  });
  $ctrl.handleItems = $injector.invoke(handleItems, null, { $ctrl: $ctrl });
  $ctrl.$onChanges = $injector.invoke($onChanges, null, {
    $ctrl: $ctrl,
    $utils: $utils
  });

  $utils.buildGridOptions = $injector.invoke(buildGridOptions, null, {
    $ctrl: $ctrl,
    $scope: $scope
  });

  /*----------------------------------------*/
  /* Create the grid to initialize the app. */
  /*----------------------------------------*/
  $utils.buildGridOptions();
}

/*****************************************************************************
 * buildGridOptions */
/**
 * @ngdoc    function
 * @name     buildGridOptions
 * @returns  {object} uiGrid definition object
 * @description
 * Generates the uiGrid definition object to be used with the main grid.
 *****************************************************************************/
/* @ngInject */ function buildGridOptions(uiGridConstants, $ctrl, $scope) {
  return function () {
    /*----------------------------------------------------*/
    /* Template for the actions column. The first option, */
    /* `View Items` is hidden when displaying programs.   */
    /*----------------------------------------------------*/
    var actionsTemplate =
      '<div class="ui-grid-cell-contents ng-binding ng-scope"> ' +
      '<table><tr>' +
      '<td style="width:25px;" ng-hide="grid.appScope.$ctrl.isPrograms">' +
      '<span style="cursor:pointer;" class="glyphicon glyphicon-list-alt csm-grid-space-target" title="View Items" ng-click="grid.appScope.$ctrl.handleItems(row.entity.id, row.entity.name)"></span>' +
      '</td>' +
      '<td style="width:25px;"><span style="cursor:pointer;" class="glyphicon glyphicon-paperclip csm-grid-space-target" title="View Activity" ng-click="grid.appScope.$ctrl.handleItems(row.entity.id, row.entity.name, true)"></span></td>' +
      '<td style="width:25px;"><span style="cursor:pointer;" class="glyphicon glyphicon-edit      csm-grid-space-target" title="Change"        ng-click="grid.appScope.$ctrl.changeFundraiser(row.entity.id)"></span></td>' +
      '<td style="width:25px;"><span style="cursor:pointer;" class="glyphicon glyphicon-trash     csm-grid-space-target" title="Delete"        ng-click="grid.appScope.$ctrl.dropFundraiser(row.entity.id)"></span></td>' +
      '</tr></table>' +
      '</div>';

    /*------------------------------------------------------------------*/
    /* Row template to add double click functionality to each grid row. */
    /*------------------------------------------------------------------*/
    var dblClickTemplate =
      '<div ng-dblclick="grid.appScope.$ctrl.changeFundraiser(row.entity.id)" \
              ng-repeat="(colRenderIndex, col) in colContainer.renderedColumns track by col.colDef.name" \
                  class="ui-grid-cell" ui-grid-cell> \
        </div>';

    /** Utility function to return inactive cell class for inactive clubs. */
    function getInactiveCellClass(grid, row, col) {
      return !row.entity.active ? 'inactive-content' : '';
    }

    $ctrl.grid = {
      appScope: $scope,
      enableColumnMenus: false,
      enableFiltering: true,
      enableHorizontalScrollbar: uiGridConstants.scrollbars.WHEN_NEEDED,
      enableVerticalScrollbar: uiGridConstants.scrollbars.WHEN_NEEDED,
      rowTemplate: dblClickTemplate,
      onRegisterApi: function (gridApi) {
        $ctrl.gridApi = gridApi;
      },
      columnDefs: [
        {
          cellClass: getInactiveCellClass,
          field: 'name',
          minWidth: 240
        },
        {
          cellClass: getInactiveCellClass,
          cellFilter: 'date:"MM/dd/yyyy"',
          field: 'startDate',
          filterCellFiltered: true,
          type: 'date',
          width: 110,
          minWidth: 110
        },
        {
          cellClass: getInactiveCellClass,
          cellFilter: 'date:"MM/dd/yyyy"',
          field: 'endDate',
          filterCellFiltered: true,
          type: 'date',
          width: 110,
          minWidth: 110
        },
        {
          cellClass: getInactiveCellClass,
          displayName: 'Note',
          /*---------------------------------------------------------*/
          /* The note field on Fundraisers is on the notes property, */
          /* and for Programs is on the description property.        */
          /*---------------------------------------------------------*/
          field: $ctrl.isPrograms ? 'description' : 'notes',
          minWidth: 175
        },
        {
          cellClass: getInactiveCellClass,
          displayName: 'Active?',
          field: 'active',
          width: '8%',
          minWidth: 85,
          cellFilter: 'boolToString',
          filter: {
            term: true,
            type: uiGridConstants.filter.SELECT,
            selectOptions: [
              { value: null, label: 'ALL' },
              { value: true, label: 'Y' },
              { value: false, label: 'N' }
            ]
          }
        },
        {
          cellTemplate: actionsTemplate,
          displayName: 'Actions',
          enableFiltering: false,
          enableSorting: false,
          field: 'actions',
          pinnedRight: true,
          /*-------------------------------------*/
          /* Programs will not display the `View */
          /* Item` option, reduce column width.  */
          /*-------------------------------------*/
          minWidth: $ctrl.isPrograms ? 71 : 95,
          width: $ctrl.isPrograms ? 71 : 95
        }
      ]
    };
  };
}

/*****************************************************************************
 * changeFundraiser */
/**
 * @ngdoc    function
 * @name     changeFundraiser
 * @methodOf fundraisers.controller:MainController
 * @param    {Number} id Fundraiser id to modify
 * @description
 * Brings up the dialog to update the existing fundraiser. Upon update, the
 * fundraiser is replaced, the list of fundraiser is resorted and the grid is
 * updated.
 *****************************************************************************/
/* @ngInject */ function changeFundraiser(
  AddChangeFundraiserDialog,
  Alert,
  $ctrl
) {
  return function (id) {
    AddChangeFundraiserDialog.show(
      id,
      $ctrl.isPrograms,
      null,
      $ctrl.handleProgramGet,
      $ctrl.handleProgramSave
    ).then(function (updated) {
      /*-------------------------------------------------*/
      /* Find the fundraiser/program that's been         */
      /* modified in the grid and update its properties. */
      /*-------------------------------------------------*/
      var idx = $ctrl.grid.data
        .map(function (f) {
          return f.id;
        })
        .indexOf(updated.id);
      $ctrl.grid.data[idx] = {
        id: updated.id,
        name: updated.name,
        active: updated.active,
        description: updated.description,
        notes: updated.notes,
        startDate: updated.startDate,
        endDate: updated.endDate
      };

      Alert.success(
        ' ',
        ($ctrl.isPrograms ? 'Program' : 'Fundraiser') + ' Updated'
      );
    });
  };
}

/*****************************************************************************
 * dropFundraiser */
/**
 * @ngdoc    function
 * @name     dropFundraiser
 * @methodOf fundraisers.controller:MainController
 * @param    {Number} id Fundraiser id to drop
 * @description
 * Removes the passed fundraiser ID from the system.
 *****************************************************************************/
/* @ngInject */ function dropFundraiser(Alert, BusyScreen, FundRaiser, $ctrl) {
  return function (id) {
    Alert.confirm(
      'Are you sure you want to delete the selected ' +
        ($ctrl.isPrograms ? 'program?' : 'fundraiser?'),
      'Confirm Delete'
    ).then(function () {
      /*-------------------------------------------*/
      /* Drop program using the provided external  */
      /* function. If a fundraiser, drop normally. */
      /*-------------------------------------------*/
      BusyScreen.promise(
        ($ctrl.isPrograms
          ? $ctrl.handleProgramDelete({ id: id })
          : FundRaiser.drop(id)
        ).then(
          function () {
            /*--------------------------------*/
            /* Remove deleted item from grid. */
            /*--------------------------------*/
            var idx = $ctrl.grid.data
              .map(function (f) {
                return f.id;
              })
              .indexOf(id);
            $ctrl.grid.data.splice(idx, 1);
            Alert.success(
              ' ',
              ($ctrl.isPrograms ? 'Program' : 'Fundraiser') + ' Deleted'
            );
          },
          function (resp) {
            Alert.error(resp.parsedResponse.message(), 'Delete Failed');
          }
        )
      );
    });
  };
}

/*****************************************************************************
 * handleItems */
/**
 * @ngdoc    function
 * @name     handleItems
 * @methodOf fundraisers.controller:MainController
 * @param    {Number}  id            Fundraiser id to handle
 * @param    {Boolean} activityMode  True=Display activity info.
 * @description
 * Click handler for the View Items and View Activity buttons in the grid
 * Actions column.
 *****************************************************************************/
/* @ngInject */ function handleItems(Alert, FundraiserItemsDialog, $ctrl) {
  return function (id, name, activityMode) {
    FundraiserItemsDialog.show(
      id,
      name,
      activityMode,
      $ctrl.isPrograms,
      $ctrl.useExpenseRevenue
    ).then(angular.noop);
  };
}

/*****************************************************************************
 * $onChanges */
/**
 * @ngdoc  function
 * @name   $onChanges
 * @param    {Object}  changes  Object containing the bound properties.
 * @description
 * Fired by angular when the bound properties have been changed from outside
 * the component. The updates values are placed on the controller.
 *****************************************************************************/
/* @ngInject */ function $onChanges($ctrl, $utils) {
  return function (changes) {
    /*--------------------------------------------------------*/
    /* When switching from displaying programs to fundraisers */
    /* and back, rebuild grid options to show/hide the `View  */
    /* Items` option in the actions column.                   */
    /*--------------------------------------------------------*/
    if (changes.isPrograms) {
      $ctrl.isPrograms = changes.isPrograms.currentValue;
      $utils.buildGridOptions();
    }

    if (changes.useExpenseRevenue)
      $ctrl.useExpenseRevenue = changes.useExpenseRevenue.currentValue;

    if (changes.fundraisersList)
      $ctrl.grid.data = changes.fundraisersList.currentValue;

    if (changes.clubId) $ctrl.clubId = changes.clubId.currentValue;

    if (changes.handleProgramDelete)
      $ctrl.handleProgramDelete = changes.handleProgramDelete.currentValue;

    if (changes.handleProgramGet)
      $ctrl.handleProgramGet = changes.handleProgramGet.currentValue;

    if (changes.handleProgramSave)
      $ctrl.handleProgramSave = changes.handleProgramSave.currentValue;
  };
}
